import React from 'react';

import PropTypes from 'prop-types';

import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';

const WaitingListModal = ({ modalRef, messages, onDismiss, primaryButtonOnClick, backUrl }) => (
    <ModalComponent isVerticalCentered canCloseModal={false} modalRef={modalRef}>
        <InfoPage
            diskButtonOnClick={onDismiss}
            iconName="rocket-80"
            iconColor="primary"
            headerText={messages.waitingListHeaderInfo}
            secondaryText={messages.waitingListHeaderText}
            primaryButtonType="button"
            primaryButtonCaption={messages.waitingListHeaderButton}
            primaryButtonOnClick={primaryButtonOnClick}
            backUrl={backUrl}
            isTagA
            primaryButtonDataTestId="waiting-list-disclaimer-agree-button"
        />
    </ModalComponent>
);

WaitingListModal.propTypes = {
    modalRef: PropTypes.shape({ current: PropTypes.object }),
    messages: PropTypes.object,
    onDismiss: PropTypes.func,
    primaryButtonOnClick: PropTypes.func,
    backUrl: PropTypes.string,
};

export default WaitingListModal;
